import { offerRejected } from 'services/typewriter';
import { flatten } from '../../../utils';
import {
  getEntity,
  segmentBrandObject,
  segmentCompanyObject,
  segmentOfferObject,
  segmentContextObject,
} from './helpers';

export default async ({ data: values }: Data) => {
  const { history, log, updated } = values;
  const lastTransition = history[ history.length -1 ] ?? updated;
  const offer = flatten(values);
  const brand = await getEntity('brands', offer['brand']);
  const company = await getEntity('companies', brand['company']);
  offerRejected({
    context: segmentContextObject(company, brand),
    brand: segmentBrandObject(brand, company),
    company: segmentCompanyObject(company),
    offer: segmentOfferObject(offer),
    rejection: {
      reason: lastTransition?.comment ?? log,
      rejector: {
        id: lastTransition?.by?.id,
        email: lastTransition?.by?.mail,
      }
    }
  });
};
